let _debounce = function (fn, delay) {
  var delays = delay || 200
  var timer
  return function () {
    var th = this
    var args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(th, args)
    }, delays)
  }
}
let _throttle = function (fn, interval) {
  var last
  var timer
  var intervals = interval || 200
  return function () {
    var th = this
    var args = arguments
    var now = +new Date()
    if (last && now - last < intervals) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        last = now
        fn.apply(th, args)
      }, intervals)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}

export {
  _debounce,
  _throttle
}



// WEBPACK FOOTER //
// ./src/utils/public.js